import TebligatController from "../../../haciz/TebligatController";
import {TebligatEvrakTypeEnum} from "../../../uyap/enum/TebligatEvrakTypeEnum";
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {ITask} from "../GorevYoneticisiTypes";
import {TopluTalepGonderTaskCevap} from "./TopluHacizHazirlaTaskHandler";
import {TopluHacizGonderTaskResponse} from "./TopluHacizGonderTaskHandler";
import {getGonderilenTaleplerStr} from "../../../utils/talepBilgileriUtils";
import {
    durdurucuHataMi,
    MERNIS_ADRES_KODU,
    tebligatAdresDegeri,
    tebligatAdresKodu,
    uyapHataKodu,
    uyapHataMesaji
} from "../../../utils/tebligatTalepUtils";
import {guncelTebligatTurleriniGetir} from "../../../haciz/guncelTebligatTurleri";
import {StatusEnum} from "../../../enum/StatusEnum";
import {TaskDurum} from "../../../enum/TaskDurum";
import JSZip from "jszip";
import app from "@/main";
import {IKisiTumDVO} from "@/plugins/uyap-plugin/uyap/CommonInterfaces";

interface TebligatAdresParams {
    adresTuru: number,
    adresTuruAciklama: string,
    adres: string
}

/**
 * Bir adres türünün dosya içindeki sorgu sonucu:
 * - "adres": portal gibi üretilmiş değer
 * - "yok": dosya durdurulur
 * - "gorevdeki": görevdeki adres gönderilir (eski davranış)
 */
type AdresCozumu = { tur: "adres", adres: string } | { tur: "yok", mesaj: string } | { tur: "gorevdeki" };

/**
 * UYAP'ın errorCode'lu cevabı UyapRequest'te mesajıyla birlikte reddediliyor. Kod, görev
 * sonucunda görünsün diye mesaja ekleniyor: "İşlem Başarısız..." gibi genel mesajlar tek
 * başına teşhis koydurmuyor (DEV-3519).
 */
function hataMesajiOlustur(e: unknown, evrakTutar: number): string {
    const mesaj = uyapHataMesaji(e);
    const hataKodu = uyapHataKodu(e);
    if (!hataKodu)
        return mesaj;
    // "talep tutarı": hata evrak hazırlanırken de gelebilir; o durumda hiçbir şey gönderilmemiştir.
    const tutar = evrakTutar > 0 ? ", talep tutarı: " + evrakTutar.toFixed(2) + " TL" : "";
    return mesaj.trim() + " (UYAP hata kodu: " + hataKodu + tutar + ")";
}

export class TopluTebligatGonderTaskHandler extends AbstractTaskHandler {
    params: any[] = [];

    async handle(task: ITask): Promise<ITask> {
        let data: TopluTalepGonderTaskCevap = new TopluTalepGonderTaskCevap(task.data.dosya, task.data.params, task.data.borclu);
        let dosya = await app.$uyap.DosyaBul().run(task);
        data.dosya = dosya;
        this.params = data.params.tebligatParams;
        let response: TopluHacizGonderTaskResponse = {
            dosyaEsasNo: data.dosya.dosyaNo,
            icraDairesi: data.dosya.birimAdi,
            message: "",
            evraklar: []
        };
        let tebligatController: TebligatController | null = null;
        try {
            // Tür adı ve ücret gönderim anında, bu avukatın UYAP'ından alınır (DEV-3519).
            const tebligatTurleri = await guncelTebligatTurleriniGetir();
            tebligatController = new TebligatController(data.borclu, data.dosya, tebligatTurleri);
            const adresOnbellegi: { [adresKodu: string]: AdresCozumu } = {};
            const t = data.borclu.tebligat;
            for (const param of this.params) {
                switch (param.className) {
                    case TebligatEvrakTypeEnum.YUZUCDAVETIYESININ_TEBLIGE_CIKARTILMASI: {
                        tebligatController.yuz3DavetiyesininTebligeCikartilmasiEkle(await this.adresiCoz(data, t.yuzucDavetiyesininTebligeCikartilmasiParams, adresOnbellegi));
                        break;
                    }
                    case TebligatEvrakTypeEnum.BakiyeBorcMuhtirasininTebligeCikartilmasi: {
                        tebligatController.bakiyeBorcMuhtirasininTebligeCikartilmasiEkle(await this.adresiCoz(data, t.bakiyeBorcMuhtirasininTebligeCikartilmasiParams, adresOnbellegi));
                        break;
                    }
                    case TebligatEvrakTypeEnum.IcraOdemeEmrininTebligeCikartilmasi: {
                        tebligatController.icraOdemeEmrininTebligeCikartilmasiEkle(await this.adresiCoz(data, t.icraOdemeEmrininTebligeCikartilmasiParams, adresOnbellegi));
                        break;
                    }
                    case TebligatEvrakTypeEnum.KiymetTakdirininTebligeCikartilmasi: {
                        tebligatController.kiymetTakdirininTebligeCikartilmasiEkle(await this.adresiCoz(data, t.kiymetTakdirininTebligeCikartilmasiParams, adresOnbellegi));
                        break;
                    }
                    case TebligatEvrakTypeEnum.TaahuduKabulMuhtirasiTebligi: {
                        tebligatController.taahhuduKabulMuhtirasiTebligiEkle(await this.adresiCoz(data, t.taahuduKabulMuhtirasiTebligiParams, adresOnbellegi));
                        break;
                    }
                    case TebligatEvrakTypeEnum.TemlikBilgisininBildirilmesi: {
                        tebligatController.temlikbilgisininBildirilmesiEkle(await this.adresiCoz(data, t.temlikBilgisininBildirilmesiParams, adresOnbellegi));
                        break;
                    }
                    case TebligatEvrakTypeEnum.YenilemeEmrininTebligeCikartilmasi: {
                        tebligatController.yenilemeEmrininTebligeCikartilmasiEkle(await this.adresiCoz(data, t.yenilemeEmrininTebligeCikartilmasiParams, adresOnbellegi));
                        break;
                    }
                }
            }
            await tebligatController.hacizEvrakHazirla();
            await tebligatController.hacizEvrakImzala();
            let evrakResult = await tebligatController.gonder();
            // gonder() UYAP hatasinda reject etmiyor, cevabi dondurup geciyor.
            // Kontrol edilmezse basarisiz gonderim "BITTI_BASARILI" olarak isaretleniyor.
            if (evrakResult.result === "error")
                throw new Error(evrakResult.message);
            let borcluKisi = data.borclu.borcluBilgileri as IKisiTumDVO;
            response.evraklar.push({
                message: evrakResult.message,
                status: StatusEnum.success,
                imzaliBlob: tebligatController.getHacizEvrakImzali(),
                imzasizBlob: tebligatController.getHacizEvrakImzasiz(),
                adSoyad: (borcluKisi.adi ? borcluKisi.adi : " ") + " " + (borcluKisi.soyadi ? borcluKisi.soyadi : " "),
                tcKimlikNo: (borcluKisi.tcKimlikNo ? borcluKisi.tcKimlikNo : ""),
                evrakTutari: tebligatController.evrakTutar.toFixed(2),
                params: this.params.map(u => u.talepAdi).join(', '),
                gonderilenTalepler: getGonderilenTaleplerStr(tebligatController.talepBilgileri)
            })
        } catch (e) {
            let borcluKisi = data.borclu.borcluBilgileri as IKisiTumDVO;
            response.evraklar.push({
                message: hataMesajiOlustur(e, tebligatController ? Number(tebligatController.evrakTutar) : 0),
                status: StatusEnum.error,
                imzaliBlob: null,
                imzasizBlob: null,
                adSoyad: (borcluKisi.adi ? borcluKisi.adi : " ") + " " + (borcluKisi.soyadi ? borcluKisi.soyadi : " "),
                tcKimlikNo: (borcluKisi.tcKimlikNo ? borcluKisi.tcKimlikNo : ""),
                evrakTutari: 0,
                params: this.params.map(u => u.talepAdi).join(', '),
                gonderilenTalepler: 'Yok'
            });
        }

        let zip = new JSZip();
        for (let evrak of response.evraklar) {
            if (evrak.imzaliBlob) {
                // @ts-ignore
                zip.file((evrak.adSoyad + "/" + evrak.imzaliBlob.name), evrak.imzaliBlob);
            }
        }
        let zipBlob = await zip.generateAsync({type: "blob"});
        let formData = new FormData();
        // @ts-ignore
        let name = task.birim_adi + ' ' + task.dosya_esas_no.replaceAll('/', '_') + ' Toplu Tebligat Talepleri.zip';
        formData.append('name', name);
        formData.append('file', zipBlob);
        formData.append('task_id', (task.id as string));
        await app.$http.post('/api/v1/task/file', formData);

        let errorExists = response.evraklar.filter(evrak => evrak.status == StatusEnum.error);
        task.status = TaskDurum.BITTI_BASARILI;
        if (errorExists.length == response.evraklar.length)
            task.status = TaskDurum.BITTI_HATALI;
        else if (errorExists.length > 0)
            task.status = TaskDurum.BITTI_EKSIK;
        task.response = response;
        task.description = errorExists.map(x => x.message).join(" , ");
        if (response.message != "")
            task.description = response.message;
        return task;
    }

    /**
     * Talebin adres alanını portal gibi doldurur: adres türü sorgulanır, Mernis için "VAR",
     * diğer türler için "adres il / ilçe" yazılır (DEV-3519). Görevde bu alan boş geliyordu.
     *
     * Dosya imza ve ödemeden önce yalnız Mernis'te durdurulur. Kayıt yoksa (UYAP adres ve
     * ilAdi boş 200 döndürür) ya da sorgu UYAP hata koduyla dönerse portal talebi eklemiyor.
     * Mernis'teki bu cevap şekli TDT-3528 HAR'ında görüldü. E-Tebligat ve Mersis'te "kayıt
     * yok" cevabının şekli bilinmiyor; bu türlerde ve ağ/zaman aşımı hatalarında görevdeki
     * adres gönderilir. UYAP bu adreslerle yapılan gönderimleri aylarca kabul etti.
     * Durdurma, devre kesici ve kimlik hataları yutulmaz.
     *
     * Aynı dosyadaki talepler aynı adres türünü kullanabilir; her tür, başarısız olsa da,
     * dosya başına bir kez sorgulanır.
     */
    private async adresiCoz<P extends TebligatAdresParams>(data: TopluTalepGonderTaskCevap, params: P, onbellek: { [adresKodu: string]: AdresCozumu }): Promise<P> {
        const adresKodu = tebligatAdresKodu(params.adresTuru);
        if (adresKodu === null)
            return params;
        if (!(adresKodu in onbellek))
            onbellek[adresKodu] = await this.adresSorgula(data, adresKodu, params.adresTuruAciklama);
        const cozum = onbellek[adresKodu];
        if (cozum.tur === "yok")
            throw new Error(cozum.mesaj);
        if (cozum.tur === "gorevdeki")
            return params;
        return Object.assign({}, params, {adres: cozum.adres});
    }

    private async adresSorgula(data: TopluTalepGonderTaskCevap, adresKodu: string, adresTuruAciklama: string): Promise<AdresCozumu> {
        const mernis = adresKodu === MERNIS_ADRES_KODU;
        const turAdi = adresTuruAciklama || "seçilen adres türü";
        try {
            const cevap = await app.$uyap.PortalIcraTebligatTalebiAdresSorgula().run({
                dosyaId: data.dosya.dosyaId,
                kisiKurumId: data.borclu.kisiKurumId,
                adresTuru: adresKodu
            });
            // Yalnız UYAP'ın bilinen cevap şekli (adresTuru alanı olan nesne) karar verdirir.
            // Boş ya da beklenmedik gövde, bilinmeyen durum sayılır: görevdeki adres gider.
            if (cevap == null || typeof cevap !== "object" || !(cevap as { adresTuru?: unknown }).adresTuru) {
                console.warn("Tebligat adres sorgusu beklenmedik cevap döndü, görevdeki adres gönderilecek:", adresKodu);
                return {tur: "gorevdeki"};
            }
            const adres = tebligatAdresDegeri(cevap, adresKodu);
            if (adres !== null)
                return {tur: "adres", adres: adres};
            if (mernis) {
                return {
                    tur: "yok",
                    mesaj: "Borçlunun " + turAdi + " kaydı UYAP'ta bulunamadı. UYAP portalı da bu durumda tebligat " +
                        "talebinin eklenmesine izin vermiyor; farklı bir adres türü seçerek talebi yeniden oluşturunuz."
                };
            }
            console.warn("Tebligat adresi UYAP'ta bulunamadı, görevdeki adres gönderilecek:", adresKodu);
            return {tur: "gorevdeki"};
        } catch (e) {
            if (durdurucuHataMi(e))
                throw e;
            const hataKodu = uyapHataKodu(e);
            if (mernis && hataKodu) {
                return {
                    tur: "yok",
                    mesaj: "Borçlunun " + turAdi + " sorgusu UYAP'tan hata döndü: " + uyapHataMesaji(e).trim() +
                        " (UYAP hata kodu: " + hataKodu + "). Portal bu durumda tebligat talebinin eklenmesine izin vermiyor."
                };
            }
            console.warn("Tebligat adres sorgusu başarısız, görevdeki adres gönderilecek:", adresKodu, uyapHataMesaji(e));
            return {tur: "gorevdeki"};
        }
    }
}
